import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import cn from "clsx";
import { ParcelSizeRange } from "react-migration/layouts/map/Multilayer/layer_types/OwnershipLayerType/Context";
import { ParcelSize } from "./ParcelSize";
import { Unit } from "src/js/types/DrawingItem";
import { ParcelSizeRangeInput } from "./ParcelSizeRangeInput";

// OwnershipFilters Component
export type OwnershipFiltersProps = {
  setParcelSizeRange: React.Dispatch<ParcelSizeRange>;
  parcelSizeRange: ParcelSizeRange;
  unitType: Unit;
  disabled: boolean;
};

export function OwnershipFilters({ unitType, parcelSizeRange, setParcelSizeRange, disabled }: OwnershipFiltersProps) {
  return (
    <div className="flex-col rounded-sm">
      <div className="flex items-center justify-between w-full group">
        <Title disabled={disabled} />
        <div className="flex items-center">
          <ParcelSize parcelSizeRange={parcelSizeRange} unitType={unitType} />
        </div>
      </div>
      <ParcelSizeRangeInput
        disabled={disabled}
        unitType={unitType}
        setMetricParcelSizeRange={setParcelSizeRange}
        metricParcelSizeRange={parcelSizeRange}
      />
    </div>
  );
}

const Title = ({ disabled }: { disabled: boolean }) => {
  const { t } = useTranslation();
  return (
    <h4
      className={cn("text-sm font-medium py-2", {
        "opacity-50": disabled,
      })}
    >
      {t("map.toolbar.ownership_filters.parcel_size_filter")}
    </h4>
  );
};
